var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "ma-0 pa-0",
      staticStyle: { "text-transform": "unset" },
      attrs: { text: "", color: _vm.colorIcon, id: "tab-icon" },
      on: {
        click: function($event) {
          return _vm.$emit("openTab")
        }
      }
    },
    [
      _c(
        "v-icon",
        { staticClass: "mt-1", attrs: { size: "18", left: !!_vm.text } },
        [_vm._v(" " + _vm._s(_vm.icon) + " ")]
      ),
      _vm._v("\n  " + _vm._s(_vm.text) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ae9dbe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae9dbe0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/RightSidebar/RightSidebarButton.vue
// module id = null
// module chunks = 